import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const helpData = {
  RechargeHelp: [
    {
      question: "What are the steps to recharge through TA Wallet?",
      answer: `• Login to TA Wallet
• Click on “Recharge”
• Choose the prepaid or postpaid option
• Enter mobile number and select service provider
• Enter the amount to recharge (you can also browse plans for latest offers)
• Click on "Recharge" to complete the transaction instantly`,
    },
    {
      question:
        "How much time it takes to update recharge amount to your mobile a/c?",
      answer: "It's Instant.",
    },
    {
      question: "Can I cancel a recharge?",
      answer:
        "Unfortunately, mobile operators do not provide recharge reversal. Hence, we cannot cancel it once done.",
    },
    {
      question: "I entered a wrong number to recharge, can I get a refund?",
      answer:
        "Unfortunately, mobile operators do not allow refunds for incorrect recharges. We’re unable to reverse it.",
    },
    {
      question:
        "Can I recharge for a number that has switched operators through Mobile Number Portability?",
      answer: `Yes, you can.
If the operator and circle are not auto-detected correctly, please manually select the correct details before recharging.`,
    },
    {
      question:
        "Can I recharge my Friend’s mobile phone? Is it possible to do Multiple Transaction of recharge within same time?",
      answer: `Yes, you can recharge your friend's or relative’s number using your TA Wallet a/c.

Multiple recharges for the same number at once are not allowed. Please wait 10 minutes before retrying.`,
    },
    {
      question:
        "Recharge was not done but my money deducted? What should I do?",
      answer: `Please write to us at: support@taipl.in`,
    },
  ],
};

const RechargeHelp = ({ selectedSection = "LoadMoney" }) => {
  const questions = helpData[selectedSection] || [];
  const [openIndex, setOpenIndex] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const toggleAnswer = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <Box width="100%">
      {/* Top Banner */}
      <Box
        sx={{
          width: "100%",
          height: { xs: 180, sm: 220, md: 260 },
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 1, sm: 3 },
        }}
      >
        <Box
          component="img"
          src="/Assets/Mobilerecharge.jpg"
          alt="Profile illustration"
          sx={{
            width: "100%",
            maxWidth: 1000,
            height: "100%",
            objectFit: "cover",
            borderRadius: "0 0 10px 10px",
          }}
        />
      </Box>

      {/* FAQ Heading */}
      <Box mt={2} display="flex" justifyContent="center">
        <Typography
          variant={isMobile ? "h6" : "h5"}
          fontWeight="bold"
          color="black"
        >
          Recharge Help
        </Typography>
      </Box>

      {/* FAQ List */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "900px",
          mx: "auto",
          px: { xs: 1.5, sm: 2, md: 3 },
          mt: 2,
          py: 2,
        }}
      >
        <List disablePadding>
          {questions.map((item, index) => (
            <Box
              key={index}
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                mb: 2,
                overflow: "hidden",
                boxShadow:
                  openIndex === index ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
                transition: "box-shadow 0.2s ease-in-out",
              }}
            >
              <ListItemButton
                onClick={() => toggleAnswer(index)}
                sx={{
                  borderBottom: "1px solid #eee",
                  px: 2,
                  py: 1.5,
                  borderRadius: 1,
                  backgroundColor:
                    openIndex === index ? "#e0f7fa" : "transparent",
                  "&:hover": {
                    backgroundColor:
                      openIndex === index ? "#b2ebf2" : "#f9f9f9",
                  },
                }}
              >
                <ListItemText primary={item.question} />
                {openIndex === index ? (
                  <ExpandMoreIcon sx={{ fontSize: 18 }} />
                ) : (
                  <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
                )}
              </ListItemButton>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Box px={3} py={2} bgcolor="#fafafa">
                  <Typography
                    variant="body2"
                    sx={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}
                  >
                    {item.answer}
                  </Typography>
                </Box>
              </Collapse>
            </Box>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default RechargeHelp;
